import ButtonSave from "../../UniversalEditModal/components/ButtonSave";
import PrivacySection from "./PrivacySection";
import PrivacySelect from "./sections/PrivacySelect";

interface Props {
    hasUnsavedChanges: boolean;
}

export default function UserPrivacyTab({ hasUnsavedChanges }: Props) {
    return (
        <>
            <PrivacySection
                title="Конфиденциальность"
                description="Настройте отображение информации"
            >
                <PrivacySelect
                    label="Кто видит профиль"
                    optionsName="profile_visibility"
                    selectedName="profile_visibility_selected"
                    formName="user_profile_visibility_selected"
                />

                <PrivacySelect
                    label="Кто видит статистику"
                    optionsName="stats_visibility"
                    selectedName="stats_visibility_selected"
                    formName="user_stats_visibility_selected"
                />
            </PrivacySection>

            <ButtonSave hasUnsavedChanges={hasUnsavedChanges} />
        </>
    );
}
